module.exports = __webpack_public_path__ + "img/stars-tattoo-115462-9600498.jpg";